type Summary = {
  totalSavings: number;
  savedToday: number;
};


type SummaryCardProps = {
  data: Summary;
};

const SummaryCard: React.FC<SummaryCardProps> = ({ data }) => (
  <div className=" relative z-0  bg-gradient-to-r from-[#FFEBD0] to-[#EABE83]
    rounded-bl-[20px] rounded-br-[20px]
    border-l border-r border-b border-[#FFEFD8]
    pt-[20px] pr-[32px] pb-[50px] pl-[32px]
    gap-[32px]">
    <div className="flex items-center gap-2 mb-3">
  <img src="/Vector.svg" alt="Membership Icon" className="w-6 h-6" />
  <h2 className="text-[24px] font-medium">
    Vetic Memberships
  </h2>
</div>

     
   <div className="bg-[#FFFEFC] rounded-[20px] pt-[12px] pr-[32px] pl-[32px] pb-[12px] flex justify-between items-center border-[#FFFFFF]">
  <div className="text-center">
    <p className="text-[22px] text-gray-600">Lifetime Savings</p>
    <p className="text-green-600 font-semibold text-[22px]">
      ₹{Math.trunc(data.totalSavings).toLocaleString('en-IN')}
    
    </p>
  </div>

  <div className="text-center">
    <p className="text-[22px] text-gray-600">Saved Today</p>
    <p className="text-green-600 font-semibold text-[22px]">
    ₹{Math.trunc(data.savedToday).toLocaleString('en-IN')}
  
    </p>
  </div>
    </div>
  </div>
);




export default SummaryCard